<template>
  <div class="pagination">
    <PaginationItemsShow
      :per-page="perPage"
      :per-page-choices="perPageChoices"
      @changePerPage="changePerPage"
    />
    <PaginationGoto
      :current-page="currentPage"
      :first-page="firstPage"
      :last-page="lastPageValue"
      @input="changeNumber"
    />
    <PaginationPages
      :current-page="currentPage"
      :first-page="firstPage"
      :last-page="lastPageValue"
      @input="changeNumber"
    />
    <PaginationInfo
      :total="itemsTotal"
      :per-page="perPage"
      :table-hint-text="tableHintText"
      :current-page="currentPage"
    />
  </div>
</template>

<script>
  import PaginationItemsShow from 'components/Data/Pagination/PaginationItemsShow';
  import PaginationGoto from 'components/Data/Pagination/PaginationGoto';
  import PaginationPages from 'components/Data/Pagination/PaginationPages';
  import PaginationInfo from 'components/Data/Pagination/PaginationInfo';

  export default {
    name: 'Pagination',
    components: {PaginationItemsShow, PaginationGoto, PaginationPages, PaginationInfo},
    props: {
      perPage: {
        type: Number,
        required: true
      },
      perPageChoices: {
        type: Array,
        default: () => [10, 20, 50, 100]
      },
      itemsTotal: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      },
      firstPage: {
        type: Number,
        default: 1
      },
      lastPage: {
        type: Number,
        default: 0
      },
      tableHintText: {
        type: String,
        default: ''
      }
    },
    computed: {
      defaultLastPage () {
        return this.firstPage + Math.ceil(this.itemsTotal / this.perPage) - 1;
      },
      lastPageValue () {
        return this.lastPage || this.defaultLastPage;
      }
    },
    methods: {
      changeNumber (pageNumber) {
        this.$emit('changePage', pageNumber);
      },
      changePerPage (perPage) {
        this.$emit('changePerPage', perPage);
      }
    }
  };
</script>

<style>
  .pagination {
    font-size: var(--secondary-font-size);

    display: flex;

    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;

    margin-top: 12px;
    margin-bottom: 30px;
  }

  @media (--extra-small) {
    .pagination {
      flex-direction: column;
    }
  }
</style>
